import React from "react";
import styles from "./terminosYcondiciones.module.css";
import close from './closeline.png'

const TerminosYcondiciones = ({setTerminos}) => {
  return (
    <div className={styles.contenedor} style={{zIndex:'250 '}}>
       <img src={close} className={styles.CLOSE} onClick={() => setTerminos()}></img>
      <div className={styles.contenedorTyc}>
        <h2>TÉRMINOS Y CONDICIONES PROMOCIÓN “COOL CONCIERTOS POR UN AÑO”</h2>


        <p>viernes, 1 de diciembre de 2023</p>


        <p className={styles.p2} style={{position:'relative',top:'-20px'}}>Para participar en el sorteo se deberá dar lectura y aceptación a las siguientes bases y cumplir totalmente con los requisitos y condiciones establecidos.</p>
 

 <b  style={{position:'relative',top:'-20px'}}>
 1.	ORGANIZADORA 
 </b>

 <p className={styles.p2} style={{width:'70%'}}>
-	La organizadora del sorteo es Embotelladora San Miguel del Sur S.A.C, RUC 20413940568, en las ciudad de Lima  
 </p>


 <b>
 2.	PARTICIPANTES 
 </b>


 <p className={styles.p2} style={{width:'70%', top:'20px'}}>
 Personas naturales mayores de dieciocho (18) años, con nacionalidad peruana y/o residencia en el Perú que cumplan con la mecánica y los Términos y Condiciones de la Promoción; comprando la marca de gaseosa COOL FRESH, formato de 350 ML en cualquiera de los sabores (cola negra, amarilla y piña). 
 </p>



 <p className={styles.p2} style={{width:'65%', top:'20px'}}>
 -	No participaran en los sorteos de la promoción, colaboradores de Embotelladora o empresas vinculadas. Tampoco podrán participar sus familiares hasta la tercera generación consanguínea.
  </p>
 


 <b style={{ top:'20px'}}>
 3.	VIGENCIA 
 </b>



 <p className={styles.p2} style={{ width:'70%',top:'40px'}}>
 Sorteo vigente desde el 13 de noviembre de 2023 hasta el 30 de enero de 20
  </p>


 <b style={{ top:'40px'}}>
 4.	MECÁNICA 
 </b>



 <p className={styles.p2} style={{width:'70%', top:'50px'}}>
 Los participantes deberán seguir la siguiente mecánica: 
  </p>


 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 1.	Comprar una botella de la marca COOL FRESH, formato 350 ML de los sabores cola negra, amarilla o piña. 
 </p>

 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 2.	Ingresar el código que aparece debajo de la tapa a la página:
<a href="www.coolfresh.pe">www.coolfresh.pe</a> 
 </p>

 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 3.	Una vez ingresado el código ya estas participando del sorteo.
 </p>

 

 <b style={{ top:'40px'}}>
 5.	PREMIOS:
 </b>



 {/* <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
-	10 entradas dobles valorizadas en S/ 600 cada una. Las entradas serán válidas solo para el ingreso a conciertos realizados a nivel nacional en Perú, desde febrero de 2024 hasta enero de 2025. Las entradas no incluyen pasajes, viáticos ni estadías.
 </p> */}


 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 -	Cada ganador tendrá acceso a 2 entradas por mes valorizadas en S/. 300 soles cada una. En total cada ganador recibirá 24 entradas en 1 año.
 </p>



 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 -	Como premio consuelo, se entregarán 60 mil botellas de Cool Fresh de 350 ml de forma gratuita entre diciembre 2023 y enero 2024.
 </p>



 
 <p className={styles.p2}  style={{width:'85%', top:'50px'}}>
 -	Después de cada sorteo (9 de enero del 2024 y 6 de febrero del 2024), los ganadores tendrán un mes como fecha límite para acercarse a solicitar su premio. Pasada la fecha, no habrá lugar a reclamo.
 </p>



 <b style={{ top:'40px'}}>
 6.	PUBLICACIÓN DE RESULTADOS Y ENTREGA DE PREMIOS 
 </b>



 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
Se realizarán 2 sorteos en las siguientes fechas:
 </p>

 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 -	09 de enero del 2024 (se anunciarán a los 05 primeros ganadores de las entradas)
  </p>


 <p className={styles.p2}  style={{width:'80%', top:'50px'}}>
 -	6 de febrero del 2024 (donde se mencionarán a los últimos 05 ganadores de las entradas).
  </p>

 <b style={{ top:'40px'}}>
 7. LIMITACIONES DE RESPONSABILIDAD
 </b>



 <p className={styles.p2}   style={{width:'80%', top:'50px'}}>
 Embotelladora, se reserva el derecho a descalificar a los participantes si observa conductas de manipulación y/o maniobras engañosas que vulneren o alteren, de forma directa o indirecta, los Términos y Condiciones o mecánica de la promoción.
  </p>

 <b style={{ top:'40px'}}>

 8.	PROTECCIÓN DE DATOS PERSONALES 
  </b>



 <p className={styles.p2} style={{width:'80%', top:'50px'}}>
 De conformidad con la Ley N° 29733, Ley de Protección de Datos Personales, desde el momento de su ingreso y/o utilización al portal el usuario da expresamente su consentimiento para el tratamiento de los datos personales que por el sean facilitados o que se faciliten a través de su ingreso al portal o por cualquier medio. Asimismo, el usuario consiente expresamente que Embotelladora San Miguel del Sur S.A.C pueda ceder los datos personales, a terceros. Para cualquier consulta o solicitud escribir al siguiente correo protecciondatospersonales@esms.com.pe 
 </p>


 



      </div>
    </div>
  );
};

export default TerminosYcondiciones;
